import React, { useEffect, useState } from 'react';

import { generatePath } from 'react-router';
import {
  Route,
  Switch,
  useHistory,
  useLocation,
  useParams,
  useRouteMatch,
} from 'react-router-dom';
import OnboardingFormAntz from 'registration/components/non_hiring/OnboardingFormAntz';

import ErrorBoundary from 'shared/components/ErrorBoundary';
import activateABTest, {
  getRegVariantChar,
} from 'shared/helpers/activateABTest';
import { parsePageQuery } from 'shared/helpers/query';
import withTracking from 'shared/helpers/withTracking';

import { getPreviewTrackingParams } from '../helpers/getPreviewTrackingParams';

export const nonHiringIntents = ['salary'];
export const nonHiringIntentRegex = `(${nonHiringIntents.join('|')})`;

const TechOnboardLiteContainer = () => {
  const history = useHistory();
  const location = useLocation();
  const { intent, type } = useParams();

  const { path } = useRouteMatch();
  const funnelChar = useParams().funnelChar || '';

  let abTestVariantGroup;
  switch (intent) {
    case 'salary':
      abTestVariantGroup = 'techOnboardingLiteSalary';
      break;
    default:
      abTestVariantGroup = 'techOnboardingLite';
  }

  const [regVariant] = useState(activateABTest(abTestVariantGroup));
  useEffect(() => {
    const query = parsePageQuery(location.search);

    const mpOptions = getPreviewTrackingParams(
      query.preview_checked,
      query.preview_enrolled
    );

    mpOptions['Onboard Lite Variant'] = regVariant;
    mixpanel.track('Onboard Lite Visited', mpOptions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const regVariantChar = getRegVariantChar(regVariant);
  if (regVariantChar !== funnelChar && nonHiringIntents.includes(intent)) {
    const newPath = generatePath(path, {
      type,
      intent,
      funnelChar: regVariantChar,
    });
    history.replace({
      pathname: newPath,
      search: location.search,
    });
    // Avoids a redirect loop that recursively appends `/1` to the URL when the
    // funnelChar is missing from the URL.
    return null;
  }

  return (
    <Switch>
      <ErrorBoundary>
        <Route path={`${path}/:step?`}>
          <OnboardingFormAntz />
        </Route>
      </ErrorBoundary>
    </Switch>
  );
};

export default withTracking(TechOnboardLiteContainer);
